import stylesheet from './ContentItem.scss?inline';

import CustomComponent from '../../base/customComponent/CustomComponent';

const VARIANTS = ['vertical', 'horizontal'];
const DEFAULT_VARIANT = 'vertical';

export class NXTContentItem extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get variant() {
        const value = this.getAttribute('variant');
        return value && VARIANTS.includes(value) ? value : DEFAULT_VARIANT;
    }

    getBreakpointVariants(): string[] {
        const additionalClasses: string[] = [];
        for (const breakpoint of ['md', 'lg', 'xl', 'xxl']) {
            const attributeName = `variant-${breakpoint}`;
            if (this.hasAttribute(attributeName)) {
                additionalClasses.push(`variant-${this.getAttribute(attributeName)}-${breakpoint}-up`);
            }
        }
        return additionalClasses;
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            'content-item',
            `variant-${this.variant}`,
            ...this.getBreakpointVariants(),
        );
        container.innerHTML = `
            <div class="image"><slot name="image"></slot></div>
            <div class="text">
                <div class="title"><slot name="title"></slot></div>
                <div class="content"><slot name="content"></slot></div>
            </div>
        `;
        this.setHasSlottedToParent(container);
        return container;
    }
}

customElements.define('nxt-content-item', NXTContentItem);
